
export const mapOrder = (array, order, key) => {
  // eslint-disable-next-line func-names
  array.sort(function (a, b) {
    const A = a[key];
    const B = b[key];
    if (order.indexOf(`${A}`) > order.indexOf(`${B}`)) {
      return 1;
    }
    return -1;
  });
  return array;
};

export const getDateWithFormat = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; // January is 0!

  const yyyy = today.getFullYear();
  if (dd < 10) {
    dd = `0${dd}`;
  }
  if (mm < 10) {
    mm = `0${mm}`;
  }
  return `${dd}.${mm}.${yyyy}`;
};

export const getCurrentTime = () => {
  const now = new Date();
  return `${now.getHours()}:${now.getMinutes()}`;
};

export const setPointCoin = (coin) => {
  return Number(coin).toFixed(2)
}

export const getMoneyComma = (coin) => {
  return Number(coin).toLocaleString();
}

export const getDateChange = (date) => {
  var today = new Date(date);
  var year = today.getFullYear();
  var month = ('0' + (today.getMonth() + 1)).slice(-2);
  var day = ('0' + today.getDate()).slice(-2);
  
  return year + '-' + month  + '-' + day;
}


export const getCoinAmount = (value, decimal = 3, type="all") => {
  if (value === undefined) return 0;

  let result = Number(value).toFixed(decimal).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); 
  
  if (type === 'all') 
    return result;
  else if (type ==='essence')
    return result.split('.')[0];
  else
    return result.split('.')[1];
}

export const getRate =(value, decimal = 3) => {
  return Number(value).toFixed(decimal).toString();
}

